import { render } from "./DeliveryInformation.vue?vue&type=template&id=b120f002"
import script from "./DeliveryInformation.vue?vue&type=script&lang=js"
export * from "./DeliveryInformation.vue?vue&type=script&lang=js"

import "./DeliveryInformation.vue?vue&type=style&index=0&id=b120f002&lang=css"
script.render = render

export default script